import React from 'react';

exports.CheckBoxList = React.createClass({

  propTypes: {
    defaultData: React.PropTypes.array,
    onChange: React.PropTypes.func,
    name: React.PropTypes.string
  },

  getInitialState: function () {
    return {
      data: this.props.defaultData || []
    };
  },

  handleItemChange: function (e) {
    var newData = [];

    this.state.data.forEach(function (item) {
      if (item.value == e.target.value) {
        item.checked = e.target.checked;
      }
      newData.push(item);
    });

    this.setState({data: newData});

    this._detectChanges(newData);
  },

  // uncheck all items in the list
  reset: function () {
    var newData = [];
    this.state.data.forEach(function (item) {
      item.checked = false;
      newData.push(item);
    });

    this.setState({data: newData});
    this._detectChanges(newData);
  },

  checkAll: function () {
    var newData = [];
    this.state.data.forEach(function (item) {
      item.checked = true;
      newData.push(item);
    });

    this.setState({data: newData});
    this._detectChanges(newData);
  },

  _detectChanges: function (newData) {
    if (this.props.onChange) {
      this.props.onChange(_.cloneDeep(newData));
    }
  },

  render: function () {
    var {name} = this.props;
    var options;

    options = this.state.data.map(function (item, index) {
      return (
        React.createElement("label", {
            key: 'chk-' + index,
            className: "checkbox"
          },
          [React.createElement("input", {
            key: "input-" + index,
            type: "checkbox",
            name: name,
            value: item.value,
            onChange: this.handleItemChange,
            checked: Boolean(item.checked)
          }), React.createElement("i", {key: "i-" + index})], " ", item.name
        )
      );
    }.bind(this));

    return (
      React.createElement("div", {className: "checkbox-wrapper pre-scrollable js-checkbox-wrapper"},
        options
      )
    );
  }
});
